import * as React from "react";
import "../Styles/style.css";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  addDays,
  setHours,
  setMinutes,
  isSameDay,
  isBefore,
  getHours,
  getMinutes,
  startOfTomorrow,
} from "date-fns";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Modal,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { baseUrl } from "../../api/ipconfig";
import Button from "@mui/material/Button";
import InputMask from "react-input-mask";
import { AuthContext } from "../../context/AuthContext";
import Credibility from "../../images/credibility.png";
import ExpertTechnician from "../../images/expert-technician.png";
import Relaxation from "../../images/relaxation.png";
import InspectionHeaderImage from "../../images/inspection-top-img.png";
import Car1 from "../../images/car1.png";
import Car2 from "../../images/car2.png";
import Car3 from "../../images/inspection-premium.png";
import JazzCashLogo from "../../images/jazzcash-logo.png";
import PayFastLogo from "../../images/PayFastLogo.png";
import moment from "moment";
import CryptoJS from "crypto-js";
import CardCategory from "./CardCategory";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

function hash_hmac_sha256(data, key) {
  return CryptoJS.HmacSHA256(data, key).toString();
}

export default function SellThroughFameWheels() {
  const token = localStorage.getItem("token");

  const { user } = React.useContext(AuthContext);
  const history = useHistory();
  const [gateway, setGateway] = useState(null);
  const [phone, setPhone] = useState("");
  const [fullName, setFullName] = useState("");
  const [registered, setRegistered] = useState("Un-Registered");
  const [city, setCity] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [address, setAddress] = useState("");
  const [inspectionSlot, setInspectionSlot] = useState(null);
  const [error, setError] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFaildModal, setOpenFaildModal] = useState(false);
  const [successIsOpen, setSuccessIsOpen] = useState(false);
  const [make, setMake] = useState(null);
  const [makeName, setMakeName] = useState(null);
  const [modelName, setModelName] = useState(null);
  const [yearName, setYearName] = useState(null);
  const [makeId, setMakeId] = useState("");
  const [modelId, setModelId] = useState("");
  const [YearId, setYearId] = useState("");
  const [modelYear, setModelYear] = useState(null);
  const [getModel, setGetModel] = useState(null);
  const [inspectionOrder, setInspectionOrder] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [variantList, setVariantList] = useState([]);
  const [variant, setVariant] = useState("");
  const [category, setCategory] = useState(null);
  const [amount, setAmount] = useState(null);
  const [tokenResponse, setTokenResponse] = useState("");
  const [paymentResponse, setPaymentResponse] = useState({});

  const handleChange = (event, value) => {
    setGateway(value?.props?.value);
  };

  const getInspectionUpdate = async (
    responseAmount,
    responseTransactionId,
    responseBasketId
  ) => {
    try {
      await axios.get(`${baseUrl}/statuswiseinspectionlistupdate`, {
        params: {
          payment_method: "PayFast",
          security_deposit: responseAmount,
          inspection_id: responseBasketId,
          payment_token: responseTransactionId,
          payment_status: 1,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    //JazzCash Parameters
    const responseCodeJazzCash = params.get("responsecode");
    const responseMessageJazzCash = params.get("ResponseMessage");

    //PayFast Parameters
    const responseCode = params.get("err_code");
    const responseMessage = params.get("err_msg");
    const responseAmount = params.get("transaction_amount");
    const responseTransactionId = params.get("transaction_id");
    const responseBasketId = params.get("basket_id");

    if (params?.size > 0) {
      if (
        responseCode === "000" ||
        responseCode === "200" ||
        responseCode === "121" ||
        responseCodeJazzCash === "000" ||
        responseCodeJazzCash === "121" ||
        responseCodeJazzCash === "200"
      ) {
        setSuccessIsOpen(true);
        setPaymentResponse({
          responseMessage,
          responseAmount,
          responseTransactionId,
          responseBasketId,
        });
        if (
          responseCode &&
          responseAmount &&
          responseTransactionId &&
          responseBasketId &&
          responseMessage
        ) {
          getInspectionUpdate(
            responseAmount,
            responseTransactionId,
            responseBasketId
          );
        }
        if (responseCodeJazzCash && responseMessageJazzCash) {
          setPaymentResponse({
            responseMessage: responseMessageJazzCash,
          });
        }
        setTimeout(() => {
          setSuccessIsOpen(false);
          history.push("/");
        }, 4000);
      } else if (
        responseCode === "002" ||
        responseCode === "001" ||
        responseCode === "97" ||
        responseCode === "106" ||
        responseCode === "3" ||
        responseCode === "14" ||
        responseCode === "54" ||
        responseCode === "13" ||
        responseCode === "126" ||
        responseCode === "75" ||
        responseCode === "14" ||
        responseCode === "15" ||
        responseCode === "42" ||
        responseCode === "423" ||
        responseCode === "41" ||
        responseCode === "801" ||
        responseCode === "802" ||
        responseCode === "803" ||
        responseCode === "804" ||
        responseCode === "805" ||
        responseCode === "806" ||
        responseCode === "807" ||
        responseCode === "808" ||
        responseCode === "809" ||
        responseCode === "810" ||
        responseCode === "811" ||
        responseCode === "812" ||
        responseCode === "813" ||
        responseCode === "850" ||
        responseCode === "851" ||
        responseCode === "79" ||
        responseCode === "901" ||
        responseCode === "9000" ||
        responseCodeJazzCash === "134" ||
        responseCodeJazzCash === "124" ||
        responseCodeJazzCash === "210" ||
        responseCodeJazzCash === "157" ||
        responseCodeJazzCash === "210" ||
        responseCodeJazzCash === "500" ||
        responseCodeJazzCash === "400" ||
        responseCodeJazzCash === "404" ||
        responseCodeJazzCash === "403" ||
        responseCodeJazzCash === "401" ||
        responseCodeJazzCash === "302"
      ) {
        getInspectionUpdate(
          responseAmount,
          responseTransactionId,
          responseBasketId
        );
        if (responseCodeJazzCash && responseMessageJazzCash) {
          setPaymentResponse({
            responseMessage: responseMessageJazzCash,
          });
        }
        setOpenFaildModal(true);

        setTimeout(() => {
          setOpenFaildModal(false);
          history.push("/car-inspection");
        }, 4000);
      } else {
      }
    }
  }, [history]);

  const getAccessToken = async (token) => {
    try {
      const response = await axios.get(`${baseUrl}/gettoken`, {
        params: {
          BASKET_ID: token || inspectionOrder?.inspection_id,
          CURRENCY_CODE: "PKR",
          TXNAMT: amount,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setTokenResponse(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const url = window.location.href;

  const handlePayFastFormSubmit = () => {
    const form = document.createElement("form");
    form.method = "POST";
    form.id = "PayFast_payment_form";
    form.name = "PayFast-payment-form";
    form.action =
      "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

    const CURRENCYCODE = document.createElement("input");
    CURRENCYCODE.type = "hidden";
    CURRENCYCODE.name = "CURRENCY_CODE";
    CURRENCYCODE.value = "PKR";
    form.appendChild(CURRENCYCODE);

    const MERCHANTID = document.createElement("input");
    MERCHANTID.type = "hidden";
    MERCHANTID.name = "MERCHANT_ID";
    MERCHANTID.value = 20579;
    form.appendChild(MERCHANTID);

    const MERCHANTNAME = document.createElement("input");
    MERCHANTNAME.type = "hidden";
    MERCHANTNAME.name = "MERCHANT_NAME";
    MERCHANTNAME.value = "FameWheels";
    form.appendChild(MERCHANTNAME);

    const ACCESSTOKEN = document.createElement("input");
    ACCESSTOKEN.type = "hidden";
    ACCESSTOKEN.name = "TOKEN";
    ACCESSTOKEN.value = tokenResponse?.ACCESS_TOKEN;
    form.appendChild(ACCESSTOKEN);

    const BASKETID = document.createElement("input");
    BASKETID.type = "hidden";
    BASKETID.name = "BASKET_ID";
    BASKETID.value = inspectionOrder?.inspection_id;
    form.appendChild(BASKETID);

    const TXNAMTInput = document.createElement("input");
    TXNAMTInput.type = "hidden";
    TXNAMTInput.name = "TXNAMT";
    TXNAMTInput.value = amount;
    form.appendChild(TXNAMTInput);

    const ORDERDATE = document.createElement("input");
    ORDERDATE.type = "hidden";
    ORDERDATE.name = "ORDER_DATE";
    ORDERDATE.value = tokenResponse?.GENERATED_DATE_TIME;
    form.appendChild(ORDERDATE);

    const SUCCESSURL = document.createElement("input");
    SUCCESSURL.type = "hidden";
    SUCCESSURL.name = "SUCCESS_URL";
    SUCCESSURL.value = `${url}`;
    form.appendChild(SUCCESSURL);

    const FAILUREURL = document.createElement("input");
    FAILUREURL.type = "hidden";
    FAILUREURL.name = "FAILURE_URL";
    FAILUREURL.value = `${url}`;
    form.appendChild(FAILUREURL);

    const CHECKOUTURL = document.createElement("input");
    CHECKOUTURL.type = "hidden";
    CHECKOUTURL.name = "CHECKOUT_URL";
    CHECKOUTURL.value = "https://www.famewheels.com/";
    form.appendChild(CHECKOUTURL);

    const CUSTOMEREMAIL = document.createElement("input");
    CUSTOMEREMAIL.type = "hidden";
    CUSTOMEREMAIL.name = "CUSTOMER_EMAIL_ADDRESS";
    CUSTOMEREMAIL.value = user?.email;
    form.appendChild(CUSTOMEREMAIL);

    const CUSTOMERMOBILENO = document.createElement("input");
    CUSTOMERMOBILENO.type = "hidden";
    CUSTOMERMOBILENO.name = "CUSTOMER_MOBILE_NO";
    CUSTOMERMOBILENO.value = user?.phone;
    form.appendChild(CUSTOMERMOBILENO);

    const SOMERANDOMSTRING = document.createElement("input");
    SOMERANDOMSTRING.type = "hidden";
    SOMERANDOMSTRING.name = "SIGNATURE";
    SOMERANDOMSTRING.value = "SOMERANDOM-STRING";
    form.appendChild(SOMERANDOMSTRING);

    const MERCHANTCART = document.createElement("input");
    MERCHANTCART.type = "hidden";
    MERCHANTCART.name = "VERSION";
    MERCHANTCART.value = "MERCHANT-CART0.1";
    form.appendChild(MERCHANTCART);

    const TXNDESCInput = document.createElement("input");
    TXNDESCInput.type = "hidden";
    TXNDESCInput.name = "TXNDESC";
    TXNDESCInput.value = "Item Purchased from Cart";
    form.appendChild(TXNDESCInput);

    const PROCCODEInput = document.createElement("input");
    PROCCODEInput.type = "hidden";
    PROCCODEInput.name = "PROCCODE";
    PROCCODEInput.value = "00";
    form.appendChild(PROCCODEInput);

    const ECOMMPURCHASE = document.createElement("input");
    ECOMMPURCHASE.type = "hidden";
    ECOMMPURCHASE.name = "TRAN_TYPE";
    ECOMMPURCHASE.value = "ECOMM_PURCHASE";
    form.appendChild(ECOMMPURCHASE);

    const STOREID = document.createElement("input");
    STOREID.type = "hidden";
    STOREID.name = "STORE_ID";
    STOREID.value = "";
    form.appendChild(STOREID);

    const RECURRINGTXN = document.createElement("input");
    RECURRINGTXN.type = "hidden";
    RECURRINGTXN.name = "RECURRING_TXN";
    RECURRINGTXN.value = "true";
    form.appendChild(RECURRINGTXN);

    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (tokenResponse?.ACCESS_TOKEN) {
      handlePayFastFormSubmit();
    }
  }, [tokenResponse]);

  const [postToken, setPostToken] = useState(null);

  useEffect(() => {
    const generateToken = () => {
      const newToken = uuidv4().replace(/-/g, "").slice(0, 12);
      setPostToken(newToken);
    };

    generateToken();
  }, []);
  const inspectionSubmit = async (e) => {
    e.preventDefault();
    if (
      city &&
      fullName &&
      phone &&
      address &&
      makeId &&
      modelId &&
      YearId &&
      inspectionSlot
    ) {
      try {
        const inspectionSlotLocal = inspectionSlot
          ? inspectionSlot.toLocaleString()
          : "";

        const formData = new FormData();

        formData.append("post_token", postToken);
        formData.append("name", fullName);
        formData.append("phone", phone);
        formData.append("address", address);
        formData.append("inspection_slot", inspectionSlotLocal);
        formData.append("user_id", user?.id || 0);
        formData.append("cityName", city);
        formData.append("makeName", makeId);
        formData.append("modelName", modelId);
        formData.append("yearName", YearId);
        formData.append("registeredIn", registered);

        const response = await axios.post(
          `${baseUrl}/ordersalethorughfamewheel`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setInspectionOrder(response?.data);

        setOpenSuccessModal(true);

        getAccessToken(response?.data?.inspection_id);
      } catch (err) {
        setError(err.response);
      }
    } else {
      alert("Please fill all fields carefully.");
    }
  };

  const handleDateTimeChange = (date) => {
    const currentTime = new Date();
    const selectedTime = date || currentTime;

    if (
      isSameDay(selectedTime, currentTime) &&
      isBefore(selectedTime, currentTime)
    ) {
      const currentHour = getHours(currentTime);
      const currentMinute = getMinutes(currentTime);
      const updatedSlot = setHours(
        setMinutes(currentTime, currentMinute),
        currentHour
      );
      setInspectionSlot(updatedSlot);
    } else {
      setInspectionSlot(selectedTime);
    }
  };

  const minDate = startOfTomorrow();
  const maxDate = addDays(minDate, 5);
  const minTime = setHours(setMinutes(new Date(), 0), 10);
  const maxTime = setHours(setMinutes(new Date(), 0), 17);
  const timeIntervals = 60;

  const filterPassedTime = (time) => {
    const currentTime = new Date();
    const currentHour = getHours(currentTime);
    const currentMinute = getMinutes(currentTime);

    if (isSameDay(inspectionSlot, currentTime)) {
      return (
        getHours(time) > currentHour ||
        (getHours(time) === currentHour && getMinutes(time) >= currentMinute)
      );
    }

    return true;
  };

  const filterDate = (date) => {
    if (inspectionSlot && isSameDay(inspectionSlot, date)) {
      return getHours(inspectionSlot) <= 17;
    }
    return true;
  };

  const packages = [
    {
      img: Car1,
      title: "Basic package",
      about: "Upto 1000cc",
      price: "PKR 2000",
    },
    {
      img: Car2,
      title: "Standard package",
      about: "1001cc - 2000cc",
      price: "PKR 4000",
    },
    {
      img: Car3,
      title: "Premium package",
      about: "Suv’s, 4x4, Jeeps and German Cars",
      price: "PKR 6000",
    },
  ];

  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/byMake`);

        setMake(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  useEffect(() => {
    const fetchVariant = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarientList`, {
          params: {
            modelId: modelId,
            yearId: YearId,
          },
        });

        setVariantList(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (yearName) {
      fetchVariant();
    } else {
      setVariantList([]);
    }
  }, [modelName, yearName]);

  const handleMakeChange = (e) => {
    const selectedMake = make?.find((item) => item.makeName === e.target.value);
    if (selectedMake) {
      setMakeId(selectedMake.makeId);
    } else {
      setMakeId("");
    }
    setMakeName(e.target.value);
  };

  const handleModelChange = (e) => {
    const selectedModel = getModel.find(
      (item) => item.modelName === e.target.value
    );
    if (selectedModel) {
      setModelId(selectedModel.modelId);
    } else {
      setModelId("");
    }
    setModelName(e.target.value);
  };

  const handleYearChange = (e) => {
    const selectedYear = modelYear.find((item) => item.year === e.target.value);
    if (selectedYear) {
      setYearId(selectedYear.yearId);
    } else {
      setYearId("");
    }
    setYearName(e.target.value);
  };

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/model-by-make?make_id=${makeId}`
        );

        setGetModel(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (makeId) {
      fetchModel();
    } else {
      setGetModel([]);
    }
  }, [makeId]);

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchYear();
  }, []);

  useEffect(() => {
    if (category <= 1000) {
      setAmount(2000);
    } else if (category >= 1001 && category <= 2000) {
      setAmount(4000);
    } else if (category > 200) {
      setAmount(6000);
    }
  }, [category]);
  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarient`, {
          params: {
            variant_id: variant,
          },
        });

        setCategory(response.data?.engine_capacity);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (variant) {
      fetchFeatures();
    }
  }, [variant]);

  const [cities, setCities] = React.useState("");

  React.useEffect(() => {
    const fetchCity = async () => {
      try {
        const response = await axios.get(`${baseUrl}/cities`);

        setCities(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCity();
  }, []);
  const onClose = () => {
    setIsOpen(false);
    setMakeName(null);
    setModelName(null);
    setYearName(null);
    setMakeId("");
    setGetModel(null);
  };

  const handleConfirmVehicle = () => {
    setIsOpen(false);

    setVehicleType(`${makeName} ${modelName} ${yearName} ${variant}`);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal position-relative p-4">
          <div className="modalBody_area successBox  px-2 text-center">
            <h3 className="pt-2 mb-5">Select Your Vehicle</h3>

            <div className="container">
              <div className="col-12">
                <div className="mb-3 text-start">
                  <label for="vehicleMake" className="form-label">
                    Select Make
                  </label>
                  <select
                    className="form-select"
                    id="vehicleMake"
                    aria-label="Default select example"
                    required
                    value={makeName}
                    onChange={handleMakeChange}
                  >
                    <option selected value=" ">
                      Select Make
                    </option>
                    {make &&
                      make.map((item) => (
                        <option key={item.makeId} value={item.makeName}>
                          {item.makeName}
                        </option>
                      ))}
                  </select>
                  <div id="CityHelp" className="form-text">
                    Mention your vehicle's make (e.g. Honda)
                  </div>
                </div>
              </div>

              {makeName !== null && (
                <div className="col-12">
                  {makeId && getModel?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        value={modelName}
                        onChange={handleModelChange}
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                        {getModel &&
                          getModel.map((item) => (
                            <option key={item.modelId} value={item.modelName}>
                              {item.modelName}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Model (e.g. Civic)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                      </select>

                      <div id="CityHelp" className="form-text text-danger">
                        Select make first
                      </div>
                    </div>
                  )}
                </div>
              )}
              {modelName && modelName !== "" && (
                <div className="col-12">
                  {makeId && modelName !== " " && modelYear?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        value={yearName}
                        onChange={handleYearChange}
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                        {modelYear &&
                          modelYear.map((item) => (
                            <option key={item.yearId} value={item.year}>
                              {item.year}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Year (e.g. 2018)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                      </select>
                      <div id="CityHelp" className="form-text text-danger">
                        Select Model first
                      </div>
                    </div>
                  )}
                </div>
              )}
              {yearName && yearName !== "" && (
                <div className="col-12 text-start">
                  {modelName && yearName !== " " && variantList?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleYear" className="form-label">
                        Variant (optional)
                        {/* <span  className="form-text"> (Optional) </span> */}
                      </label>
                      <select
                        className="form-select"
                        id="vehicleYear"
                        aria-label="Default select example"
                        value={variant}
                        onChange={(e) => setVariant(e.target.value)}
                      >
                        <option selected value=" ">
                          Select {modelName && modelName} {yearName && yearName}{" "}
                          Variant
                        </option>
                        {variantList &&
                          variantList.map((item) => (
                            <option
                              key={item.featuresId}
                              value={item.featuresId}
                            >
                              {item.featureName}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention {modelName && modelName} {yearName && yearName}{" "}
                        Variant
                      </div>
                    </div>
                  ) : modelName &&
                    yearName !== " " &&
                    variantList?.length === 0 ? (
                    <>
                      <label
                        for="vehicleYear"
                        className="form-label text-start"
                      >
                        Variant
                        {/* <span  className="form-text"> (Optional) </span> */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="varient"
                        aria-describedby="VarientHelp"
                        value={variant}
                        onChange={(e) => setVariant(e.target.value)}
                      />
                      <div id="VarientHelp" className="form-text text-danger">
                        Mention {modelName && modelName} {yearName && yearName}{" "}
                        Varient
                      </div>
                    </>
                  ) : (
                    <div className="mb-3 text-start">
                      <label for="vehicleVariant" className="form-label">
                        Variant
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleVariant"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select Variant
                        </option>
                      </select>
                      <div id="CityHelp" className="form-text text-danger">
                        Select Year first
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <Button
              onClick={handleConfirmVehicle}
              variant="contained"
              className="py-2 px-4 mt-3 color-white fw-700 bgSecondary  text-capitalize"
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>

      <div className="container-fluid grad-bg90 py-0 ">
        <div className="container ">
          <div className="row align-items-center w-100">
            <div className="col-lg-6 col-12 text-lg-start  ms-2 ms-md-0 ">
              <h2 className="fw-bold color-white fs-md-1 fs-3 my-5 my-md-0">
                Get your car registered in Sell Through FameWheels
                <p className="fs-6  fw-light mt-4">
                  Say goodbye to the hassle of selling your car! Let FameWheels
                  experts handle everything for you, from crafting the perfect
                  ad to securing the best deal. Sit back, relax, and let us
                  drive your success! Choose excellence today.
                </p>
              </h2>
            </div>
            <div className="col-lg-6 d-none d-lg-block col-12  text-end p-0">
              <img
                className="topBanner_img img-fluid "
                src={InspectionHeaderImage}
                alt="Sell through live bidding"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        {error && <p> {error} </p>}
        <form
          onSubmit={inspectionSubmit}
          className="inspectionForm postAdForm boxShadow p-4 my-5 mx-3 mx-md-3 "
        >
          <div className="row mb-3">
            <div className="col-md-4 col-6">
              <div className="mb-md-3">
                <label for="inspectionVehicle" className="form-label">
                  Make/Model/Year/Variant
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inspectionVehicle"
                  aria-describedby="inspectionVehicleHelp"
                  placeholder="Enter Make/Model/Year/Variant"
                  required
                  value={vehicleType}
                  onClick={() => setIsOpen(true)}
                  readOnly
                />
                <div id="inspectionVehicleHelp" className="form-text">
                  (e.g. Honda Civic RS 2022)
                </div>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="mb-md-3">
                <label for="inspectionCity" className="form-label">
                  Registered In
                </label>

                <select
                  className="form-select"
                  id="inspectionCity"
                  aria-label="Default select example"
                  required
                  value={registered}
                  onChange={(e) => setRegistered(e.target.value)}
                >
                  <option value="Un-Registered">Un-Registered</option>
                  {cities &&
                    cities.map((item) => (
                      <option key={item?.cityID} value={item?.cityID}>
                        {item?.cityName}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="mb-md-3">
                <label for="inspectionCity" className="form-label">
                  City
                </label>

                <select
                  className="form-select"
                  id="inspectionCity"
                  aria-label="Default select example"
                  required
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                >
                  <option value="">Select City</option>
                  {cities &&
                    cities.map((item) => (
                      <option key={item?.cityID} value={item?.cityID}>
                        {item?.cityName}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="mb-md-3">
                <label for="inspectionAddress" className="form-label">
                  Complete Street Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inspectionAddress"
                  aria-describedby="inspectionAddressHelp"
                  placeholder="House No/ Street/ Area"
                  required
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <div id="inspectionAddressHelp" className="form-text">
                  (e.g. House No 225,6Th Street, Cifton Karachi )
                </div>
              </div>
            </div>

            <div className="col-md-4 col-6 my-2 my-md-0">
              <div className="">
                <label for="vehicleYear" className="form-label d-block">
                  Inspection Slot
                </label>
                <DatePicker
                  selected={inspectionSlot}
                  onChange={handleDateTimeChange}
                  showTimeSelect
                  timeFormat="h:mm aa"
                  dateFormat="dd-MM-yyy h:mm aa"
                  placeholderText="Select Inspection Slot"
                  className="form-control w-100 "
                  minDate={minDate}
                  maxDate={maxDate}
                  minTime={minTime}
                  maxTime={maxTime}
                  timeIntervals={timeIntervals}
                  filterTime={filterPassedTime}
                  filterDate={filterDate}
                />
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div>
                <label for="inspectionName" className="form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inspectionName"
                  placeholder="Enter Full Name"
                  required
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div>
                <label for="inspectionContact" className="form-label">
                  Phone Number
                </label>
                <InputMask
                  mask="03999999999"
                  maskChar={null}
                  type="text"
                  name="inspectionContact"
                  className="form-control"
                  id="inspectionContact"
                  placeholder="Phone No. (03xxxxxxxxx)"
                  required
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="col-6 col-md-12 w-100 text-center d-md-flex justify-content-center">
              {category && category <= 1000 ? (
                <CardCategory
                  img={Car1}
                  title={"Basic package"}
                  about={"Upto 1000cc"}
                  price={"PKR 2000"}
                />
              ) : category >= 1001 && category <= 2000 ? (
                <CardCategory
                  img={Car2}
                  title={"Standard package"}
                  about={"1001cc - 2000cc"}
                  price={"PKR 4000"}
                />
              ) : category > 2000 ? (
                <CardCategory
                  img={Car3}
                  title={"Premium package"}
                  about={" Suv’s, 4x4, Jeeps and German Cars"}
                  price={"PKR 6000"}
                />
              ) : null}
            </div>


          <div className="pt-md-5 pt-4 mx-md-5  ">
            <p className="fontsizeClass">
              An initial inspection fee starting from Rs. 2000 will be levied
              based on your car's make and model upon onboarding. A commission
              of 0.5% of the final selling price will be charged upon successful
              sale of the car. <br />
              <br />
              <input
                type="checkbox"
                className="form-check-input align-content-center text-center "
                id="exampleCheck1"
                required
              />{" "}
              By enrolling for our service, you are consenting to abide by the
              Eligibility Criteria, Required Documentation, Pricing/Commission
              Structure, and{" "}
              <a href="https://www.famewheels.com/terms">
                <span className="color-secondary">Terms of Service</span>
              </a>
              .
            </p>
          </div>
          <div className="text-center pt-3  ">
            <button
              type="submit"
              className="btn bgSecondary text-white postFormBtn widthclass-customm  "
            >
              Continue
            </button>
          </div>
        </form>
      </div>

      <div className="container py-5">
        <div className="memberFormHead">
          <h4 className="pb-4 color-black text-start fs-3 ms-3  fw-700">
            Let FameWheels Help You To Sell Your Car!
          </h4>
        </div>

        <div className=" col-lg-12 col-12">
          <div className="row ">
            <div className="col-lg-4 col-6 ">
              <div className="d-flex justify-content-start text-center  align-items-center">
                <div className="">
                  <img
                    className="w-50"
                    src={ExpertTechnician}
                    alt="Expert Technician"
                    srcSet={ExpertTechnician}
                  />
                </div>

                <div className="StepperCount2">01</div>
              </div>
              <h6
                style={{ fontWeight: "800", fontSize: "22px" }}
                className="text-capitalize fontsizeClass2 text-center "
              >
                {" "}
                Dedicated Sales Expert to Sell your Car
              </h6>
            </div>

            <div className="col-lg-4 col-6 ">
              <div className="d-flex justify-content-start text-center  align-items-center">
                <div className="">
                  <img
                    className="w-50"
                    src={Relaxation}
                    alt="Relaxation"
                    srcSet={Relaxation}
                  />
                </div>

                <div className="StepperCount2">02</div>
              </div>
              <h6
                style={{ fontWeight: "800", fontSize: "22px" }}
                className="text-capitalize fontsizeClass2  text-center "
              >
                {" "}
                We Bargain for you and share the Best Offer
              </h6>
            </div>

            <div className="col-lg-4 col-6 ">
              <div className="d-flex justify-content-start  text-center   align-items-center">
                <div className="">
                  <img
                    className="w-50 "
                    src={Credibility}
                    alt="Credibility"
                    srcSet={Credibility}
                  />
                </div>

                <div className="StepperCount2 ">03</div>
              </div>
              <h6
                style={{ fontWeight: "800", fontSize: "22px" }}
                className="text-capitalize fontsizeClass2 text-center "
              >
                We ensure Safe & Secure Transaction
              </h6>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <h4 className="pb-4 text-capitalize  color-black text-center text-lg-start fs-3 fw-700">
          FameWheels Vehicle Inspection Packages
        </h4>

        <div className="d-flex justify-content-center justify-content-lg-between align-items-center gap-md-5 gap-2 flex-lg-nowrap flex-wrap">
          {packages?.map((item, index) => {
            const dynamicPrices = [4000, 6000, 8000];
            const dynamicPrice = dynamicPrices[index];

            return (
              <div
                className=" border inspection_cardPkg mb-4 position-relative p-3 shadow-sm"
                key={item.price}
                style={{ borderRadius: "10px", maxWidth: "400px" }}
              >
                <img
                  src={item.img}
                  alt="car-inspection"
                  style={{ width: "100%", borderRadius: "8px" }}
                />

                <h4 className="mt-3 text-center">{item.title}</h4>
                <p className="color-secondary fw-semibold text-center">
                  {item.about}
                </p>

                <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                  <p
                    className="color-secondary fw-bold fs-5 m-0"
                    style={{ fontSize: "1.2rem" }}
                  >
                    PKR {item?.price?.toLocaleString()}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h3>
              Inspection Token:{" "}
              {inspectionOrder && inspectionOrder.inspection_id}
            </h3>
          </div>
          <p className="m-0 p-0">Wait, do not close this window.</p>
          <p className="pt-1">Redirecting to payment... </p>
        </Box>
      </Modal>
      <Modal
        open={successIsOpen}
        onClose={() => setSuccessIsOpen(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <h3>Success!</h3>
          <h5>Inspection Slot Booked.</h5>

          <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          <p className="pt-1">We will contact you soon. Thank You!</p>
        </Box>
      </Modal>
      <Modal
        open={openFaildModal}
        onClose={() => setOpenFaildModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h2 className="color-secondary">Payment Canceled</h2>
          </div>
          <p className="m-0 p-0">{paymentResponse?.responseMessage}</p>
          <p className="pt-1">We will contact you soon. Thank You!</p>
        </Box>
      </Modal>
    </>
  );
}
